import { Box, List, ListItem, ListItemText } from '@mui/material';
import { baseTheme } from 'design-system';
import { Fragment, ReactNode } from 'react';
import { useFeatures } from 'hooks/useFeatures';
import { SelectOption } from 'generated/graphql';
import HighlightMatch from '../HighlightMatch';

const SearchListResults = ({
  filteredOptions,
  inputValue,
  onOptionClick,
  loadMoreTrigger,
  loadMoreTriggerIndex,
}: {
  filteredOptions: SelectOption[];
  inputValue: string;
  onOptionClick: (option: string, optionEntityID: string) => void;
  loadMoreTrigger?: ReactNode;
  loadMoreTriggerIndex?: number;
}) => {
  const { isEnabled } = useFeatures();
  const isQuotesSearchEnabled = isEnabled('QuotesSearch');
  return (
    <List dense>
      {filteredOptions?.length > 0 ? (
        filteredOptions.map((option, index) => (
          <Fragment key={`${option}-${index}`}>
            <ListItem
              aria-label={`Search result: ${index}`}
              onClick={() => onOptionClick(option.value, option.entityID)}
              sx={isQuotesSearchEnabled ? { cursor: 'pointer', '&:hover': { bgcolor: 'action.hover' } } : undefined}
            >
              <ListItemText
                sx={{
                  '& .MuiTypography-root': {
                    fontWeight: baseTheme.typography.fontWeightRegular,
                  },
                }}
                primary={<HighlightMatch text={option.label} subtext={inputValue} matchWords={isQuotesSearchEnabled} />}
                secondary={isQuotesSearchEnabled && option.description ? option.description : undefined}
                slotProps={{ secondary: { noWrap: true } }}
              />
            </ListItem>
            {loadMoreTrigger && index === loadMoreTriggerIndex && <Box component="li">{loadMoreTrigger}</Box>}
          </Fragment>
        ))
      ) : (
        <ListItem>
          <ListItemText primary="No results" />
        </ListItem>
      )}
    </List>
  );
};

export default SearchListResults;
